export default "__VITE_ASSET__CxJBluW2__"